export default __webpack_public_path__ + "static/media/site.2837bb10.svg";